import { StatsigProvider as Provider } from '@statsig/react-bindings'

import { Environments, EnvVariables } from '../../constants'
import { usePersistentIds } from '../../hooks/use-persistent-ids'
import { useMyOrg, useMyUser } from '../../layouts/AppStateContextLayout/utils'
import { getCurrentOS } from '../../utils/window'

type StatsigEnvironment = 'development' | 'staging' | 'production'
const StatsigEnvironmentMap: Record<Environments, StatsigEnvironment> = {
  Demo: 'staging',
  Dev: 'development',
  Local: 'development',
  Prod: 'production',
  ProdCopy: 'staging',
}

type Props = {
  children: React.ReactNode
}
const StatsigProvider = ({ children }: Props) => {
  const sdkKey = EnvVariables.StatsigApiKey
  const me = useMyUser()
  const myOrg = useMyOrg()
  const { browserId } = usePersistentIds()

  if (!sdkKey) {
    return children
  }

  return (
    <Provider
      sdkKey={sdkKey}
      user={{
        userID: `${me?.id ?? browserId}`,
        email: `${me?.emailAddress ?? ''}`,
        custom: {
          environmentName: EnvVariables.Environment,
          hostname: window.location.hostname,
          isGovWellStaff: `${!!me?.isGovWellStaff}`,
          // Statsig has a built-in OS field, but it doesn't detect iPads in desktop mode
          operatingSystemWithIPadDetection: getCurrentOS(),
          ...(myOrg?.createdAt ? { organizationCreatedAt: myOrg.createdAt } : {}),
        },
        customIDs: {
          ...(myOrg?.id ? { organizationId: `${myOrg.id}` } : {}),
        },
      }}
      options={{
        environment: {
          tier: StatsigEnvironmentMap[EnvVariables.Environment],
        },
      }}
    >
      {children}
    </Provider>
  )
}

export default React.memo(StatsigProvider)
